import { toast } from "@/components/ui/use-toast";
import { CheckCircle2, AlertCircle, Info } from "lucide-react";

export function toastSuccess(message: string) {
  toast({
    title: "Success",
    description: (
      <div className="flex items-center gap-2 text-green-600">
        <CheckCircle2 className="h-5 w-5" />
        <span>{message}</span>
      </div>
    ),
  });
}

export function toastError(message: string) {
  toast({
    title: "Error",
    description: (
      <div className="flex items-center gap-2 text-red-600">
        <AlertCircle className="h-5 w-5" />
        <span>{message}</span>
      </div>
    ),
    variant: "destructive",
  });
}

export function toastInfo(message: string) {
  toast({
    title: "Info",
    description: (
      <div className="flex items-center gap-2 text-blue-600">
        <Info className="h-5 w-5" />
        <span>{message}</span>
      </div>
    ),
  });
}